<template>
  <div class="_rfp_mctb_sstl_01_">
    <div class="_rfp_mctb_sstl_05_ rfp-mctb-common-buynow-header">
      <div class="_rfp_mctb_sstl_06_ rfp-mctb-slider-outer">
        <button
          class="_rfp_mctb_sstl_07_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
          @click="pageRedirectUrl(retailer?.RetailerUrl, retailer?.OpenInNewWindow, retailer?.Name)"
        >
          {{ buyNowText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

// :productname="buynowData.Product.Title"
// :productids="buynowData.Product.ProductId"
// :store-locator-mode-options="buynowData.Product.Retailers[0]"

export default {
  name: 'rfp-mctb-simple-single-retailer',
  props: {
    buyNowText: {
      type: String,
      required: false,
      default: '',
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      retailer: this.product?.Retailers[0],
      showWarningPopup: false,
      extraParams: {},
      popupDirection: false,
    };
  },
  created() {
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
    eventBus.on('rfp-mctb-enable-popup-direction', () => {
      this.popupDirection = true;
      this.pageRedirectUrl(
        this.retailer.RetailerUrl,
        this.retailer.OpenInNewWindow,
        this.retailer.Name,
      );
    });
  },
  methods: {
    pageRedirectUrl(redirectURL, OpenInNewWindow, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(
          window.dataLayer
            ? this.product.BuyOnlineSimpleModeTags
            : this.product.BuyOnlineSimpleModeTagsGS,
        );
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.product.Title,
              productId: this.product.ProductId,
              retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(
          `error/rfp-mctb-simple-single-retailer#pageRedirectUrl: ${service} tag parsing failed`,
          e,
        );
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
  },
};
</script>
